import React, { forwardRef, useEffect } from 'react'
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import img1 from '../assets/images/pro-img-1.png'
import img2 from '../assets/images/pro-img-2.png'
import img3 from '../assets/images/pro-img-3.png'
import img4 from '../assets/images/pro-img-4.png'
import sliderArrow from '../assets/images/slider-arrow.svg'
import bed from '../assets/images/bed.svg'
import bath from '../assets/images/bath.svg'
import size from '../assets/images/scale.svg'
import { Link } from 'react-router-dom';
import { BASE_URL } from '../api/constants'

const PropertyCard = ({ property }) => {

  return (
    <Link to={`buy-details/${property.slug}`} className="property-card border-0 h-100">
      <div className="position-relative">
        <Card.Img
          variant="top"
          src={property.image}
          alt={property.name}
        />
        {property.recommended && (
          <Badge>
            Recommended
          </Badge>
        )}
      </div>
      <Card.Body>
        <Card.Title>{property.name}</Card.Title>
        <div className="d-flex justify-content-between align-items-center">
          <h5>KES{property.price.toLocaleString()}</h5>

        </div>
        <div className="d-flex gap-3 info-box mt-2">
          <span>
            <img src={bed} alt="" />
            {property.details.bedrooms}
          </span>
          <span>
            <img src={bath} alt="" />
            {property.details.bathrooms}
          </span>
          <span>
            <img src={size} alt="" />
            {property.size_sqft}
          </span>
        </div>
      </Card.Body>
    </Link>
  );
};

const RecommendedYou = forwardRef((props, ref) => {
  const { section } = props;
  const [recommended_properties, setRecommended] = React.useState([]);

  // Default values
  const title = section?.title || "Recommended for you";
  const subtitle = section?.subtitle || "The most viewed and favorited homes.";

  const getRecommended = async () => {
    try {
      const url = `${BASE_URL}/properties/stats/recommended`;
      const res = await fetch(url);
      const data = await res.json();
      console.log(data);

      if (data?.status && Array.isArray(data.data)) {
        setRecommended(data.data);
      } else {
        setRecommended([]);
      }

    } catch (err) {
      console.error("error", err);
      setRecommended([]);
    }
  };

  useEffect(() => {
    getRecommended();
  }, []);
 


  return (
    <div ref={ref} className='recommended-you common-padding'>
      <Container>
        <Row>
          <Col>
            <div className="recommended-you-wrap d-flex justify-content-between align-items-center">
              <div className="common-header mb-0">
                <h2 dangerouslySetInnerHTML={{ __html: title }} />
                <p>{subtitle}</p>
              </div>
              <div className="button-group d-flex gap-2">
                <button
                  className="swiper-button-prev-custom btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                >
                  <img src={sliderArrow} alt="" />
                </button>
                <button
                  className="swiper-button-next-custom btn btn-danger rounded-circle d-flex align-items-center justify-content-center"
                >
                  <img src={sliderArrow} alt="" />
                </button>
              </div>
            </div>
          </Col>
        </Row>

        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          navigation={{
            prevEl: '.swiper-button-prev-custom',
            nextEl: '.swiper-button-next-custom',
          }}
          breakpoints={{
            576: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 3.5,
            }
          }}
          style={{ padding: '10px 0' }}
        >
          {recommended_properties.map((property) => (
            <SwiperSlide key={property.id}>
              <PropertyCard property={property} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
});

export default RecommendedYou;